import { gql } from "@apollo/client";

export const CREATE_WORK_ORDER_STAGE_MUTATION = gql`
  mutation CreateMasterWorkOrderStage($input: CreateMasterWorkOrderStageInput!) {
    createMasterWorkOrderStage(input: $input) {
      id
      name
      color_code
      is_default
      display_order
      created_at
      updated_at
    }
  }
`;

// Update Work Order Stage Mutation

export const UPDATE_WORK_ORDER_STAGE_MUTATION = gql`
  mutation UpdateMasterWorkOrderStage($input: UpdateMasterWorkOrderStageInput!) {
    updateMasterWorkOrderStage(input: $input) {
      id
      name
      color_code
      is_default
      display_order
      created_at
      updated_at
    }
  }
`;

// Delete Work Order Stage Mutation

export const DELETE_WORK_ORDER_STAGE_MUTATION = gql`
  mutation DeleteMasterWorkOrderStage($input: DeleteMasterDataInput!) {
    deleteMasterWorkOrderStage(input: $input) {
      success
      message
    }
  }
`;

// Create Assignment Mutation
